import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import api from '../../../app/api/api';
import Kitchen from '../../../app/data/models/kitchens/kitchen';

export interface KitchenListState {
  kitchens: Kitchen[];
  status: string;
}

const initialState: KitchenListState = {
  kitchens: [],
  status: 'idle',
};

export const fetchKitchenListAsync = createAsyncThunk<Kitchen[], string>(
  'kitchens/list',
  async (restaurantId, thunkApi) => {
    try {
      return await api.Kitchen.list(`${restaurantId}`);
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return thunkApi.rejectWithValue({ error: error.response?.data });
      }
      return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

export const deleteKitchenAsync = createAsyncThunk<
  boolean,
  { restaurantId: string; kitchenId: string }
>('kitchens/delete', async ({ restaurantId, kitchenId }, thunkApi) => {
  try {
    await api.Kitchen.delete(restaurantId, kitchenId);
    thunkApi.dispatch(fetchKitchenListAsync(restaurantId));
    return true;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return thunkApi.rejectWithValue({ error: error.response?.data });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const kitchenListSlice = createSlice({
  name: 'kitchens',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchKitchenListAsync.pending, (state) => {
      state.status = 'pendingFetchKitchens';
    });
    builder.addCase(fetchKitchenListAsync.fulfilled, (state, action) => {
      state.kitchens = action.payload;
      state.status = 'idle';
    });
    builder.addCase(fetchKitchenListAsync.rejected, (state) => {
      state.status = 'idle';
    });
    builder.addCase(deleteKitchenAsync.pending, (state) => {
      state.status = 'pendingDeleteKitchen';
    });
    builder.addCase(deleteKitchenAsync.fulfilled, (state) => {
      state.status = 'idle';
    });
    builder.addCase(deleteKitchenAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
